/**
*	@description Contains omniture helper methods used throughout the site
*/
var Omniture = (function () {

	/**
	*	@description Method used clear properties on the global omniture AppMeasurement object
	*/
	function clearProperties () {
		// Contains manually set properties on the global omniture AppMeasurement object
		// If other properties are ever set in the future, they should be added to this list
	    var properties = ['eVar43', 'pageName', 'prop13', 'events', 'Event93', 'eVar69'];

		// Iterate over relevant properties and reset
		for (var i = 0; i < properties.length; i++) {
			Omniture_AppMeasurement[properties[i]] = undefined;
		}
	};

	/**
	*	@description Method used initialize omniture tracking links
	*/
	function initializeTrackingLinks () {
		var $main = $('main.container');

		$main.on(
			'click',
			'.omniture-track-link',
			function (evt) { handleTrackLinkClick(evt); }
		);

		$main.on(
			'click',
			'.omniture-track-link-pdf',
			function (evt) { handleTrackLinkPdfClick(evt); }
		);
	};

	/**
	*	@description Method used to handle a click event for an omniture tracking link
	*	@param evt A click event
	*/
    function handleTrackLinkClick(evt) {
		var target = evt.currentTarget;
		var trackLinkValue = $(target).data('omniture-track-link-value');

		// Track link
		trackLink(target, trackLinkValue);
	};

	/**
	*	@description Method used to handle a click event for an omniture tracking link pdf
	*	@param evt A click event
	*/
    function handleTrackLinkPdfClick(evt) {
		var target = evt.currentTarget;
		var trackLinkPdfValue = $(target).data('omniture-track-link-pdf-value');

		// Track link
		trackLink(target, trackLinkPdfValue);
	};

	/**
	*	@description Method used to track events on the global omniture AppMeasurement object
	*	@param data An object containing omniture data to track (i.e. {  pageName: 'pageName' })
	*/
    function track(data) {
		try {
			// Clear existing properties on glboal omniture AppMeasurement object
			clearProperties();

			// Track event on global omniture AppMeasurement object
			Omniture_AppMeasurement.t(data);
		} catch (e) {
			console.log(e);
		}
	};

	/**
	*	@description Method used to track a link on the global omniture AppMeasurement object
	*	@param target A DOM element
	*	@param trackLinkValue A track link value
	*/
    function trackLink(target, trackLinkValue) {
		// Track link on global omniture AppMeasurement object
		Omniture_AppMeasurement.tl(target, 'o', trackLinkValue);
	};

	return {
		InitializeTrackingLinks: initializeTrackingLinks,
		Track: track
	};

})();
